import React from 'react';
import Modal from '../../components/Modal';
import ModalHeading from '../../components/Modal/ModalHeading';
import ModalForm from '../../components/Modal/ModalForm';
import InputsSection from '../../components/Modal/InputsSection';
import ModalButtons from '../../components/Modal/ModalButtons';

const DeleteUserModal = ({ data }) => {
	const { deleteUserModalStatus, closeDeleteModal, handleDeleteUser } = data;

	return (
		<Modal show={deleteUserModalStatus.status}>
			<ModalHeading heading={`Delete User`} />
			<ModalForm>
				<InputsSection>
					<p className='delete_text'>
						Are you sure, you want to delete{' '}
						<span>
							{deleteUserModalStatus.data && deleteUserModalStatus.data.length === 2 ? (
								deleteUserModalStatus.data[0]
							) : (
								''
							)}
						</span>{' '}
						?
					</p>
				</InputsSection>
				<ModalButtons
					submitButtonLabel={`Delete User`}
					onSubmit={handleDeleteUser}
					cancelButtonLabel='Cancel'
					onCancel={closeDeleteModal}
					style={{ justifyContent: 'flex-start' }}
				/>
			</ModalForm>
		</Modal>
	);
};

export default DeleteUserModal;
